import React from 'react'
import { Form } from 'react-bootstrap'

export const HereditaryCell = ({ relationShip, onChangeCheckbox }) => (
  <td className="align-middle">
    <Form.Check type="switch" onChange={onChangeCheckbox} checked={relationShip.isChecked} />
  </td>
)
